import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

export default function SchedulingWizardFooter({ actions, activeStep, onStepChange, steps, status }) {
  const previous = activeStep > 0 ? steps[activeStep - 1] : null;
  const next = activeStep < steps.length - 1 ? steps[activeStep + 1] : null;

  return (
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        zIndex: (theme) => theme.zIndex.appBar - 1,
        mx: { xs: -2, sm: 0 },
        mt: 3,
        px: { xs: 2, sm: 2.5 },
        py: 1.5,
        bgcolor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: { xs: 0, sm: 1 },
      }}
    >
      <Stack direction={{ xs: "column", md: "row" }} alignItems={{ md: "center" }} justifyContent="space-between" spacing={1.5}>
        <Typography variant="body2" color="text.secondary">
          {status}
        </Typography>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          {previous && (
            <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => onStepChange(activeStep - 1)}>
              {previous.backLabel}
            </Button>
          )}
          {next && (
            <Button variant="contained" endIcon={<ArrowForwardIcon />} onClick={() => onStepChange(activeStep + 1)}>
              {next.continueLabel}
            </Button>
          )}
          {actions}
        </Stack>
      </Stack>
    </Box>
  );
}
